
<div class="container">
    <div class="page_header">
        <div class="left">
            <div class="close_icon_wrapper" (click)="cancel()" >
                <app-svg-icon class="close_icon" [path]="'/assets/icons/close_icon.svg'"></app-svg-icon>
            </div>
            <div class="title">@if(readOnlyMode) {View Container} @else {Edit Container}</div>
        </div>
        <div class="right">
                @if (!readOnlyMode){
                    <button class="btn secondary_button" (click)="cancel()">Cancel</button>
                    <button class="btn primary_button" (click)="saveForm()">Update</button>
                }
        </div>
    </div>

    <div class="form-container card-layout">
        <app-dynamic-form
        [formGroup]="containerForm"
        [formConfig]="formConfig"
        (onValueChange)="onAutoCompleteSuggestionSelected($event)"
        >
        </app-dynamic-form>
        <!-- <form [formGroup]="containerForm">

            <div class="form-row">
                <div class="form-item">
                <label for="containerNo" class="required_field_label">Container No</label>
                <input type="text" id="containerNo" formControlName="containerNo" placeholder="Enter Container No."/>
                <div class="form_validation_error" [ngClass]="{ form_error: (containerForm.get('containerNo')?.invalid && containerForm.get('containerNo')?.touched)}">
                    <small *ngIf="containerForm.get('containerNo')?.errors?.['required']">Container No is required</small>
                </div>
            </div>

            <div class="form-row">
                <div class="form-item">
                    <label for="accountHolderId" class="required_field_label">Account Holder</label>
                    <app-autocomplete-dropdown
                        id="accountHolderId"
                        name="accountHolderId"
                        formControlName="accountHolderId"
                        class = "autocomplete-dropdown"
                        [placeholder]="'Select'"
                        [apiUrl]="'v1/customers/list'"
                        [selectFields]="['id', 'name', 'code']"
                        [filterByKeys]="['name', 'code']"
                        [limit]="10"
                        [orderBy]="{ name: 'asc' }"
                        [filterByKey]="'name'"
                        [bindLabel]="'name'"
                        [bindValue]="'id'"
                        [displayColumns]="[
                            { key: 'name', header: 'Name' },
                            { key: 'code', header: 'Code' },
                        ]"
                        [disable]="containerForm.disabled"
                        >
                    </app-autocomplete-dropdown>
                    <div class="form_validation_error" [ngClass]="{ form_error: (containerForm.get('accountHolderId')?.invalid && containerForm.get('accountHolderId')?.touched)}">
                        <small *ngIf="containerForm.get('accountHolderId')?.errors?.['required']">Account Holder is required</small>
                    </div>
                </div>

                <div class="form-item">
                    <label for="shippingLineId" class="required_field_label">Shipping Line</label>
                    <app-autocomplete-dropdown
                        id="shippingLineId"
                        formControlName="shippingLineId"
                        class = "autocomplete-dropdown"
                        [placeholder]="'Select'"
                        [apiUrl]="'v1/customers/list'"
                        [selectFields]="['id', 'name', 'customerType']"
                        [filterByKeys]="['name']"
                        [limit]="10"
                        [orderBy]="{ name: 'asc' }"
                        [filterByKey]="'name'"
                        [bindLabel]="'name'"
                        [bindValue]="'id'"
                        [disable]="containerForm.disabled"
                        [additionalFilters]='[
                            {
                                "name": "customerType",
                                "alias": "customerType",
                                "operator": "IN",
                                "value": ["LINE_AGENT"]
                            },
                            {
                                "name": "active",
                                "alias": "active",
                                "operator": "EQ",
                                "value": ["true"]
                            }
                        ]'
                        [displayColumns]="[
                            { key: 'name', header: 'Name' },
                        ]"
                        >
                    </app-autocomplete-dropdown>
                    <div class="form_validation_error" [ngClass]="{ form_error: (containerForm.get('shippingLineId')?.invalid && containerForm.get('shippingLineId')?.touched)}">
                        <small *ngIf="containerForm.get('shippingLineId')?.errors?.['required']">Shipping Line is required</small>
                    </div>
                </div>
                <div class="form-item">
                    <label for="vesselId" class="required_field_label">Vessel Name</label>
                    <app-autocomplete-dropdown
                        id="vesselId"
                        name="vesselId"
                        formControlName="vesselId"
                        class = "autocomplete-dropdown"
                        [placeholder]="'Select'"
                        [apiUrl]="'v1/vessel-port-train-details/list'"
                        [selectFields]="['id', 'vesselName','viaNo']"
                        [filterByKeys]="['vesselName']"
                        [limit]="10"
                        [orderBy]="{ vesselName: 'asc' }"
                        [filterByKey]="'vesselName'"
                        [bindLabel]="'vesselName'"
                        [bindValue]="'id'"
                        [disable]="containerForm.disabled"
                        [displayColumns]="[
                            { key: 'vesselName', header: 'Vessel Name' },
                            { key: 'viaNo', header: 'Via No' },
                        ]"
                        >
                    </app-autocomplete-dropdown>
                    <div class="form_validation_error" [ngClass]="{ form_error: (containerForm.get('vesselId')?.invalid && containerForm.get('vesselId')?.touched)}">
                        <small *ngIf="containerForm.get('vesselId')?.errors?.['required']">Vessel is required</small>
                    </div>
                </div>
            </div>


            <form-row>
                <div class="form-item">
                    <label for="isoCode" class="required_field_label">ISO Code</label>
                    <app-autocomplete-dropdown
                        id="isoCode"
                        name="isoCode"
                        formControlName="isoCode"
                        class = "autocomplete-dropdown"
                        [placeholder]="'Select'"
                        [apiUrl]="'v1/size-type/alias/list'"
                        [selectFields]="['id', 'alias', 'sizeTypeId.size AS size', 'sizeTypeId.type AS type']"
                        [filterByKeys]="['alias']"
                        [limit]="10"
                        [orderBy]="{ alias: 'asc' }"
                        [filterByKey]="'alias'"
                        [bindLabel]="'alias'"
                        [bindValue]="'alias'"
                        [disable]="containerForm.disabled"
                        [displayColumns]="[
                            { key: 'alias', header: 'ISO' },
                            { key: 'size', header: 'Size' },
                            { key: 'type', header: 'Type' },
                        ]"
                        (suggestionSelected) = "onIsoCodeSelection($event)"
                        >
                    </app-autocomplete-dropdown>
                    <div class="form_validation_error" [ngClass]="{ form_error: (containerForm.get('isoCode')?.invalid && containerForm.get('isoCode')?.touched)}">
                        <small *ngIf="containerForm.get('isoCode')?.errors?.['required']">ISO Code is required</small>
                    </div>
                </div>

                <div class = "contSizeTypeGroup">
                    <div class="form-item">
                        <label for="containerSize" class="required_field_label">Size</label>
                        <input type="text" id="containerSize" formControlName="containerSize" readonly/>
                    </div>

                    <div class="form-item">
                        <label for="containerType" class="required_field_label">Type</label>
                        <input type="text" id="containerType" formControlName="containerType" readonly/>
                    </div>
                </div>
            </form-row>

            <div class="form-row">
                <div class="form-item">
                    <label for="lineSealNo">Line Seal</label>
                    <input type="text" id="lineSealNo" formControlName="lineSealNo" placeholder="Enter line seal no"/>
                </div>

                <div class="form-item">
                    <label for="tareWeight">Tare Weight</label>
                    <input type="number" id="tareWeight" formControlName="tareWeight" placeholder="Enter Tare Weight"/>
                </div>

                <div class="form-item grossWeightField">
                    <label for="cargoWeight">Cargo Weight</label>
                    <input type="number" id="cargoWeight" formControlName="cargoWeight" placeholder="Enter Cargo Weight"/>
                </div>
            </div>

            <div class="form-row">
                <div class="form-item">
                    <label for="scanType">Scan Type</label>
                    <app-multi-select>
                        id="scanType"
                        formControlName="scanType"
                        [options]="scanTypeOptions"
                        [displayKey]="'value'"
                        [valueKey]="'key'"
                        [isMultiSelect]="false"
                        [placeholder]="'Select Scan Type'"
                    </app-multi-select>
                </div>
                <div class="form-item">
                    <label for="importType">Import Type</label>
                    <app-multi-select>
                        id="importType"
                        formControlName="importType"
                        [options]="imporTypeOptions"
                        [displayKey]="'value'"
                        [valueKey]="'key'"
                        [isMultiSelect]="false"
                        [placeholder]="'Select Import Type'"
                    </app-multi-select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-item">
                    <app-toggle toggleId="hazardous"
                    label="Hazardous"
                    formControlName="hazardous"
                    (toggleChange)="onHazChange($event)"
                    ></app-toggle>
                </div>
                <div class="form-item">
                    <label for="imdgClass">IMDG Class</label>
                    <input type="text" id="imdgClass" formControlName="imdgClass" placeholder="Enter IMDG Class"/>
                </div>

                <div class="form-item">
                    <label for="unNo">UN No</label>
                    <input type="text" id="unNo" formControlName="unNo" placeholder="Enter UN No."/>
                </div>
            </div>

            <div class="form-row">
                <div class="form-item">
                    <app-toggle toggleId="odc"
                    label="ODC"
                    formControlName="odc"
                    (toggleChange)="onOdcChange($event)"
                    ></app-toggle>
                </div>
                <app-toggle toggleId="reeferPlugin"
                    label="Reefer Plugin"
                    formControlName="reeferPlugin"
                    (toggleChange)="onReeferPluginChange($event)"
                    >
                </app-toggle>
                <app-toggle toggleId="dpd"
                    label="DPD"
                    formControlName="dpd"
                    >
                </app-toggle>
            </div>

            <div class="form-row">
                <div class="form-item">
                    <label for="doNo">DO No</label>
                    <input type="text" id="doNo" formControlName="doNo" placeholder="Enter DO No."/>
                </div>
                <div class="form-item">
                    <label for="doDate">DO Date</label>
                    <input type="date" id="doDate" formControlName="doDate" placeholder="Enter DO Date"/>
                </div>
                <div class="form-item">
                    <label for="temperature">Temperature</label>
                    <input type="date" id="" formControlName="temperature" placeholder="Enter Temperature"/>
                </div>
            </div>


            <div class="form-item conditionField" *ngIf="isFieldInGrid('condition')">
                <label for="condition" class="form-label">
                    Condition<span *ngIf="isFieldRequired('condition')" class="required">*</span>
                </label>
                <select id="condition" formControlName="condition" class="form-select" >
                    <option value="" disabled>Select</option>
                    <option *ngFor="let option of conditionOptions" [value]="option.key">{{ option.value }}</option>
                </select>
                <div class="form_validation_error" [ngClass]="{form_error: (containerForm.get('condition')?.invalid && containerForm.get('condition')?.touched)}">
                    <small *ngIf="containerForm.get('condition')?.errors?.['required']">Please select the condition</small>
                </div>
            </div>

            <div class="form-item remarksField" *ngIf="isFieldInGrid('remarks')">
                <label for="remarks" class="form-label">Remarks</label>
                <textarea class="form-text-area" id="remarks" name="remarks" placeholder="Enter remarks"></textarea>
            </div>
        </div>
        </form> -->
    </div>
</div>
